export const adminCommissions = {
  "admin.commissions.pageTitle": "Gestión de Comisiones",
  "admin.commissions.pageDescription": "Gestionar y ver todos los datos de comisiones en el sistema",

  // Tracker page translations
  "admin.commissions.tracker.title": "Rastreador de Comisiones",
  "admin.commissions.tracker.subtitle": "Seguimiento detallado de todas las actividades y transacciones de comisiones",
  "admin.commissions.tracker.errorTitle": "Error al Cargar Datos",
  "admin.commissions.tracker.errorMessage": "Error al cargar los datos del rastreador de comisiones",
  "admin.commissions.tracker.retryButton": "Reintentar",

  // Tracker filters section
  "admin.commissions.tracker.filters.title": "Filtros",
  "admin.commissions.tracker.filters.ancestorUsername": "Usuario Ancestro",
  "admin.commissions.tracker.filters.ancestorUsernamePlaceholder": "Ingrese usuario ancestro",
  "admin.commissions.tracker.filters.referralUsername": "Usuario Referido",
  "admin.commissions.tracker.filters.referralUsernamePlaceholder": "Ingrese usuario referido",
  "admin.commissions.tracker.filters.accountNumber": "Número de Cuenta",
  "admin.commissions.tracker.filters.accountNumberPlaceholder": "Ingrese número de cuenta",
  "admin.commissions.tracker.filters.level": "Nivel",
  "admin.commissions.tracker.filters.levelPlaceholder": "Seleccione nivel",
  "admin.commissions.tracker.filters.allLevels": "Todos los Niveles",
  "admin.commissions.tracker.filters.leftoverCommission": "Comisión Residual",
  "admin.commissions.tracker.filters.leftoverCommissionPlaceholder": "Seleccionar comisión residual",
  "admin.commissions.tracker.filters.allLeftover": "Todos",
  "admin.commissions.tracker.filters.leftoverYes": "Sí",
  "admin.commissions.tracker.filters.leftoverNo": "No",
  "admin.commissions.tracker.filters.period": "Período",
  "admin.commissions.tracker.filters.dateFrom": "Desde Fecha",
  "admin.commissions.tracker.filters.dateTo": "Hasta Fecha",
  "admin.commissions.tracker.filters.commissionAmount": "Monto de Comisión",
  "admin.commissions.tracker.filters.commissionMin": "Comisión Mín",
  "admin.commissions.tracker.filters.commissionMinPlaceholder": "Cantidad mínima",
  "admin.commissions.tracker.filters.commissionMax": "Comisión Máx",
  "admin.commissions.tracker.filters.commissionMaxPlaceholder": "Cantidad máxima",
  "admin.commissions.tracker.filters.profitAmount": "Monto de Ganancia",
  "admin.commissions.tracker.filters.profitMin": "Ganancia Mín",
  "admin.commissions.tracker.filters.profitMinPlaceholder": "Ganancia mínima",
  "admin.commissions.tracker.filters.profitMax": "Ganancia Máx",
  "admin.commissions.tracker.filters.profitMaxPlaceholder": "Ganancia máxima",
  "admin.commissions.tracker.filters.applyFilters": "Aplicar Filtros",
  "admin.commissions.tracker.filters.clearFilters": "Limpiar Filtros",

  // Tracker table section
  "admin.commissions.tracker.table.title": "Rastreador de Comisiones",
  "admin.commissions.tracker.table.ancestorUsername": "Ancestro",
  "admin.commissions.tracker.table.ancestorName": "Nombre Ancestro",
  "admin.commissions.tracker.table.referralUsername": "Referido",
  "admin.commissions.tracker.table.referralName": "Nombre Referido",
  "admin.commissions.tracker.table.accountNumber": "No. Cuenta",
  "admin.commissions.tracker.table.period": "Período",
  "admin.commissions.tracker.table.leftover": "Residual",
  "admin.commissions.tracker.table.leftoverYes": "Sí",
  "admin.commissions.tracker.table.leftoverNo": "No",
  "admin.commissions.tracker.table.level": "Nivel",
  "admin.commissions.tracker.table.levelCompany": "Empresa",
  "admin.commissions.tracker.table.levelLeftover": "Restante",
  "admin.commissions.tracker.table.commissionPercentage": "Porcentaje",
  "admin.commissions.tracker.table.commissionAmount": "Monto Comisión",
  "admin.commissions.tracker.table.profitAmount": "Monto Ganancia",
  "admin.commissions.tracker.table.noData": "No se encontraron datos del rastreador de comisiones",
  "admin.commissions.tracker.table.error": "Error al cargar datos del rastreador de comisiones",
  "admin.commissions.tracker.table.showing": "Mostrando",
  "admin.commissions.tracker.table.of": "de",
  "admin.commissions.tracker.table.records": "registros",

  // Profits page translations
  "admin.commissions.profits.title": "Ganancias por Comisiones",
  "admin.commissions.profits.subtitle": "Ver y analizar el historial de ganancias por comisiones",
  "admin.commissions.profits.errorTitle": "Error al Cargar Datos",
  "admin.commissions.profits.errorMessage": "Error al cargar los datos de ganancias por comisiones",
  "admin.commissions.profits.retryButton": "Reintentar",

  // Profits filters section
  "admin.commissions.profits.filters.title": "Filtros",
  "admin.commissions.profits.filters.user": "Usuario",
  "admin.commissions.profits.filters.userPlaceholder": "Ingrese nombre de usuario",
  "admin.commissions.profits.filters.period": "Período",
  "admin.commissions.profits.filters.dateFrom": "Desde Fecha",
  "admin.commissions.profits.filters.dateTo": "Hasta Fecha",
  "admin.commissions.profits.filters.commissionAmount": "Monto de Comisión",
  "admin.commissions.profits.filters.commissionMin": "Comisión Mín",
  "admin.commissions.profits.filters.commissionMinPlaceholder": "Cantidad mínima",
  "admin.commissions.profits.filters.commissionMax": "Comisión Máx",
  "admin.commissions.profits.filters.commissionMaxPlaceholder": "Cantidad máxima",
  "admin.commissions.profits.filters.leftoverCommission": "Comisión Residual",
  "admin.commissions.profits.filters.leftoverCommissionPlaceholder": "Seleccionar comisión residual",
  "admin.commissions.profits.filters.allLeftover": "Todos",
  "admin.commissions.profits.filters.leftoverYes": "Sí",
  "admin.commissions.profits.filters.leftoverNo": "No",
  "admin.commissions.profits.filters.applyFilters": "Aplicar Filtros",
  "admin.commissions.profits.filters.clearFilters": "Limpiar Filtros",

  // Profits table section
  "admin.commissions.profits.table.title": "Ganancias por Comisiones",
  "admin.commissions.profits.table.username": "Nombre de usuario",
  "admin.commissions.profits.table.name": "Nombre",
  "admin.commissions.profits.table.period": "Período",
  "admin.commissions.profits.table.commissionAmount": "Monto de Comisión",
  "admin.commissions.profits.table.leftover": "Residual",
  "admin.commissions.profits.table.leftoverYes": "Sí",
  "admin.commissions.profits.table.leftoverNo": "No",
  "admin.commissions.profits.table.noData": "No se encontraron datos de comisión",
  "admin.commissions.profits.table.error": "Error al cargar datos de comisión",
  "admin.commissions.profits.table.showing": "Mostrando",
  "admin.commissions.profits.table.of": "de",
  "admin.commissions.profits.table.records": "registros",

  // Totals page translations
  "admin.commissions.totals.title": "Totales de Comisiones",
  "admin.commissions.totals.subtitle": "Ver y analizar los ingresos totales de comisiones por usuario",
  "admin.commissions.totals.errorTitle": "Error al Cargar Datos",
  "admin.commissions.totals.errorMessage": "Error al cargar los datos de totales de comisiones",
  "admin.commissions.totals.retryButton": "Reintentar",

  // Totals filters section
  "admin.commissions.totals.filters.title": "Filtros",
  "admin.commissions.totals.filters.user": "Usuario",
  "admin.commissions.totals.filters.userPlaceholder": "Ingrese nombre de usuario",
  "admin.commissions.totals.filters.commissionAmount": "Monto de Comisión",
  "admin.commissions.totals.filters.commissionMin": "Comisión Mínima",
  "admin.commissions.totals.filters.commissionMinPlaceholder": "Monto mínimo",
  "admin.commissions.totals.filters.commissionMax": "Comisión Máxima",
  "admin.commissions.totals.filters.commissionMaxPlaceholder": "Monto máximo",
  "admin.commissions.totals.filters.applyFilters": "Aplicar Filtros",
  "admin.commissions.totals.filters.clearFilters": "Limpiar Filtros",

  // Totals table section
  "admin.commissions.totals.table.title": "Totales de Comisiones",
  "admin.commissions.totals.table.username": "Nombre de Usuario",
  "admin.commissions.totals.table.name": "Nombre",
  "admin.commissions.totals.table.totalCommission": "Comisiones Totales",
  "admin.commissions.totals.table.lastUpdate": "Última Actualización",
  "admin.commissions.totals.table.noData": "No se encontraron datos de totales de comisiones",
  "admin.commissions.totals.table.error": "Error al cargar datos de totales de comisiones",
  "admin.commissions.totals.table.showing": "Mostrando",
  "admin.commissions.totals.table.of": "de",
  "admin.commissions.totals.table.records": "registros",

  // Balances page translations
  "admin.commissions.balances.title": "Saldos de Comisiones",
  "admin.commissions.balances.subtitle": "Ver y gestionar datos de saldos de comisiones para todos los usuarios",
  "admin.commissions.balances.errorTitle": "Error al Cargar Datos",
  "admin.commissions.balances.errorMessage": "Error al cargar los datos de saldos de comisiones",
  "admin.commissions.balances.retryButton": "Reintentar",

  // Balances filters section
  "admin.commissions.balances.filters.title": "Filtros",
  "admin.commissions.balances.filters.user": "Usuario",
  "admin.commissions.balances.filters.userPlaceholder": "Ingrese nombre de usuario",
  "admin.commissions.balances.filters.balanceAmount": "Monto de Saldo",
  "admin.commissions.balances.filters.balanceMinPlaceholder": "Monto mínimo",
  "admin.commissions.balances.filters.balanceMaxPlaceholder": "Monto máximo",
  "admin.commissions.balances.filters.paidAmount": "Monto Pagado",
  "admin.commissions.balances.filters.paidMinPlaceholder": "Mínimo pagado",
  "admin.commissions.balances.filters.paidMaxPlaceholder": "Máximo pagado",
  "admin.commissions.balances.filters.applyFilters": "Aplicar Filtros",
  "admin.commissions.balances.filters.clearFilters": "Limpiar Filtros",

  // Balances table section
  "admin.commissions.balances.table.title": "Saldos de Comisiones",
  "admin.commissions.balances.table.username": "Nombre de Usuario",
  "admin.commissions.balances.table.name": "Nombre",
  "admin.commissions.balances.table.currentBalance": "Saldo Actual",
  "admin.commissions.balances.table.totalPaid": "Total Pagado",
  "admin.commissions.balances.table.lastUpdate": "Última Actualización",
  "admin.commissions.balances.table.noData": "No se encontraron datos de saldos de comisiones",
  "admin.commissions.balances.table.error": "Error al cargar datos de saldos de comisiones",
  "admin.commissions.balances.table.loading": "Cargando...",
  "admin.commissions.balances.table.showing": "Mostrando",
  "admin.commissions.balances.table.of": "de",
  "admin.commissions.balances.table.records": "registros",

  // Payments page translations
  "admin.commissions.payments.title": "Pagos de Comisiones",
  "admin.commissions.payments.subtitle": "Rastrea y gestiona el historial de pagos de comisiones",
  "admin.commissions.payments.errorTitle": "Error al Cargar Pagos",
  "admin.commissions.payments.errorMessage": "Error al cargar los datos de pagos de comisiones",
  "admin.commissions.payments.retryButton": "Reintentar",

  // Payments filters section
  "admin.commissions.payments.filters.title": "Filtros",
  "admin.commissions.payments.filters.user": "Nombre de Usuario",
  "admin.commissions.payments.filters.userPlaceholder": "Ingrese nombre de usuario",
  "admin.commissions.payments.filters.dateFrom": "Fecha de Pago Desde",
  "admin.commissions.payments.filters.dateTo": "Fecha de Pago Hasta",
  "admin.commissions.payments.filters.paymentAmountMin": "Monto Mínimo de Pago",
  "admin.commissions.payments.filters.paymentAmountMinPlaceholder": "Monto mínimo",
  "admin.commissions.payments.filters.paymentAmountMax": "Monto Máximo de Pago",
  "admin.commissions.payments.filters.paymentAmountMaxPlaceholder": "Monto máximo",
  "admin.commissions.payments.filters.paymentStatus": "Estado de Pago",
  "admin.commissions.payments.filters.paymentStatusPlaceholder": "Seleccione estado",
  "admin.commissions.payments.filters.allStatuses": "Todos los Estados",
  "admin.commissions.payments.filters.applyFilters": "Aplicar Filtros",
  "admin.commissions.payments.filters.clearFilters": "Limpiar Filtros",

  // Payments table section
  "admin.commissions.payments.table.title": "Pagos de Comisiones",
  "admin.commissions.payments.table.username": "Nombre de Usuario",
  "admin.commissions.payments.table.name": "Nombre",
  "admin.commissions.payments.table.paymentAmount": "Monto de Pago",
  "admin.commissions.payments.table.feeAmount": "Monto de Tarifa",
  "admin.commissions.payments.table.netAmount": "Monto Neto",
  "admin.commissions.payments.table.paymentDate": "Fecha de Pago",
  "admin.commissions.payments.table.paymentStatus": "Estado",
  "admin.commissions.payments.table.paymentAccount": "Cuenta de Pago",
  "admin.commissions.payments.table.noData": "No se encontraron registros de pago",
  "admin.commissions.payments.table.error": "Error al cargar datos de pago",
  "admin.commissions.payments.table.showing": "Mostrando",
  "admin.commissions.payments.table.of": "de",
  "admin.commissions.payments.table.records": "registros",
  
  // Payment status translations
  "admin.commissions.payments.status.pending": "Pendiente",
  "admin.commissions.payments.status.paid": "Pagado",
  "admin.commissions.payments.status.completed": "Completado",
  "admin.commissions.payments.status.cancelled": "Cancelado",
  "admin.commissions.payments.status.failed": "Fallido",
  "admin.commissions.payments.status.rejected": "Rechazado",

  // Models page translations
  "admin.commissions.models.title": "Modelos de Comisión",
  "admin.commissions.models.subtitle": "Ver y gestionar todos los modelos de comisión disponibles",
  "admin.commissions.models.errorTitle": "Error al Cargar Datos",
  "admin.commissions.models.errorMessage": "Error al cargar los modelos de comisión",
  "admin.commissions.models.retryButton": "Reintentar",
  "admin.commissions.models.loading": "Cargando modelos de comisión...",

  // Models card translations
  "admin.commissions.models.card.name": "Nombre",
  "admin.commissions.models.card.description": "Descripción",
  "admin.commissions.models.card.maxLevels": "Niveles Máximos",
  "admin.commissions.models.card.createdAt": "Creado el",
  "admin.commissions.models.card.updatedAt": "Actualizado el",
  "admin.commissions.models.card.levelTable.title": "Niveles de Comisión",
  "admin.commissions.models.card.levelTable.level": "Nivel",
  "admin.commissions.models.card.levelTable.percentage": "Porcentaje",
  "admin.commissions.models.card.noLevels": "No hay niveles de comisión definidos",

  // Manager page translations
  "admin.commissions.manager.title": "Gestor de Comisiones",
  "admin.commissions.manager.subtitle": "Calcular y gestionar el procesamiento mensual de comisiones",
  "admin.commissions.manager.form.title": "Cálculo de Comisiones Mensuales",
  "admin.commissions.manager.form.description": "Seleccione el mes objetivo para procesar comisiones",
  "admin.commissions.manager.form.periodLabel": "Período Objetivo",
  "admin.commissions.manager.form.periodHint": "Formato: yyyy-mm-01 (ej.",
  "admin.commissions.manager.form.periodFormatError": "El período debe estar en formato yyyy-mm-01",
  "admin.commissions.manager.form.calculateButton": "Calcular Comisiones",
  "admin.commissions.manager.form.calculating": "Calculando...",
  "admin.commissions.manager.results.title": "Resultados del Cálculo de Comisiones",
  "admin.commissions.manager.results.description": "Resultados para el mes de procesamiento",
  "admin.commissions.manager.results.processingMonth": "Mes de Procesamiento",
  "admin.commissions.manager.results.totalWorkers": "Total de Trabajadores",
  "admin.commissions.manager.results.processingDuration": "Tiempo de Procesamiento",
  "admin.commissions.manager.results.totalProcessed": "Registros Procesados",
  "admin.commissions.manager.results.totalFailed": "Registros Fallidos",
  "admin.commissions.manager.results.successRate": "Tasa de Éxito",
  "admin.commissions.manager.results.totalCommissionAmount": "Monto Total de Comisiones",
  "admin.commissions.manager.results.totalLeftoverAmount": "Monto Total Restante",
  "admin.commissions.manager.logs.title": "Registros de Procesamiento de Comisiones",
  "admin.commissions.manager.logs.description": "Ver registros detallados de cálculos de comisiones",
  "admin.commissions.manager.logs.filterLabel": "Filtrar por Mes",
  "admin.commissions.manager.logs.searchButton": "Buscar",
  "admin.commissions.manager.logs.clearButton": "Limpiar",
  "admin.commissions.manager.logs.showing": "Mostrando",
  "admin.commissions.manager.logs.records": "registros",
  "admin.commissions.manager.logs.noLogs": "No se encontraron registros de comisiones",
  "admin.commissions.manager.logs.table.month": "Mes",
  "admin.commissions.manager.logs.table.workerId": "ID Trabajador",
  "admin.commissions.manager.logs.table.status": "Estado",
  "admin.commissions.manager.logs.table.processed": "Procesados",
  "admin.commissions.manager.logs.table.failed": "Fallidos",
  "admin.commissions.manager.logs.table.commissionAmount": "Monto de Comisión",
  "admin.commissions.manager.logs.table.leftoverAmount": "Monto Restante",
  "admin.commissions.manager.logs.table.startedAt": "Iniciado en",
  "admin.commissions.manager.logs.table.completedAt": "Completado en",
  "admin.commissions.manager.logs.table.duration": "Duración",
  "admin.commissions.manager.error.title": "Error al Procesar Comisiones",
  "admin.commissions.manager.error.message": "Ocurrió un error al procesar las comisiones"
};
